import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success(t("common.success"));
      nav(loc.state?.from || "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("common.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-[#FAFAFA] px-6">
        <div className="w-full max-w-md card-premium p-10">
          <div className="kicker">Dikigoros.io</div>
          <h1 className="mt-3 font-display font-bold text-3xl text-slate-900">{t("auth.loginTitle")}</h1>
          <p className="mt-2 text-slate-600 text-sm">{t("auth.loginSub")}</p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <label className="kicker !text-slate-500 block mb-2">{t("auth.email")}</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none transition"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="kicker !text-slate-500 block mb-2">{t("auth.password")}</label>
              <input
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none transition"
                data-testid="login-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full rounded-full px-6 py-3 font-semibold disabled:opacity-60"
              data-testid="login-submit"
            >
              {loading ? t("common.loading") : t("auth.submit")}
            </button>
          </form>
          <div className="mt-5 flex items-center justify-between text-sm">
            <Link to="/forgot-password" className="text-[#0A192F] hover:underline" data-testid="login-forgot">{t("auth.forgot")}</Link>
            <div className="text-slate-500">
              {t("auth.noAccount")} <Link to="/signup" className="text-[#0A192F] font-medium hover:underline" data-testid="login-signup-link">{t("auth.signupHere")}</Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
